// components/ResultadoContent.jsx
import React, { useState, useEffect, useMemo } from "react";
import FoodTab from "./ResultadoTabs/FoodTab";
import TradeTab from "./ResultadoTabs/TradeTab";
import LandUseTab from "./ResultadoTabs/LandUseTab";
import GHGTab from "./ResultadoTabs/GHGTab";
import BiodiversityTab from "./ResultadoTabs/BiodiversityTab";
import { useAuth } from "../../auth/AuthContext";

export default function ResultadoContent({ resultsData }) {
  const { authFetch, bootstrapping, setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userData, setUserData] = useState(null);

  const [activeSubTab, setActiveSubTab] = useState("Food");

  // 1) Traer perfil desde BD
  useEffect(() => {
    const fetchProfile = async () => {
      setError("");
      if (bootstrapping) return;

      try {
        setLoading(true);

        const res = await authFetch("/api/auth/me", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.error || "Could not load profile.");
        }

        const u = data.user;

        const mapped = {
          first_name: u.first_name ?? "",
          second_name: u.second_name ?? "",
          last_name: u.last_name ?? "",
          email: u.email ?? "",
          userName: u.email ?? "",
          country: u.country ?? "",
          organization: u.organization_name ?? "",
        };

        setUserData(mapped);
        setUser?.(u);
      } catch (e) {
        console.error(e);
        setError(e.message || "Error loading profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [authFetch, bootstrapping, setUser]);

  const canRender = useMemo(
    () => !bootstrapping && !!userData,
    [bootstrapping, userData],
  );


  console.log("userData: ", userData);

  // 🔄 Reiniciar tab cuando cambian los datos
  useEffect(() => {
    setActiveSubTab("Food");
  }, [resultsData]);

  const subTabs = [
    { key: "Food", label: "Food Security" },
    { key: "Trade", label: "Trade" },
    { key: "Land use", label: "Land Use" },
    { key: "GHG", label: "GHG" },
    { key: "Biodiversity", label: "Biodiversity" },
  ];

  console.log("resultsData: ", resultsData);

  const first = resultsData ?? {};
  const [pathwayName, pathwayObject] = Object.entries(first)[0] ?? [];
  const chartData = pathwayObject?.charts?.[0] ?? {};

  const renderTabContent = () => {
    const country = userData?.country || "";

    switch (activeSubTab) {
      case "Food":
        return (
          <FoodTab
            data={chartData.Food ?? {}}
            pathway={pathwayName}
            pathwayId={pathwayObject.id}
            country={country}
          />
        );

      case "Trade":
        return (
          <TradeTab
            data={chartData.Trade ?? {}}
            pathway={pathwayName}
            pathwayId={pathwayObject.id}
            country={country}
          />
        );

      case "Land use":
        return (
          <LandUseTab
            data={chartData["Land use"] ?? {}}
            pathway={pathwayName}
            pathwayId={pathwayObject.id}
            country={country}
          />
        );

      case "GHG":
        return (
          <GHGTab
            data={chartData.GHG ?? {}}
            pathway={pathwayName}
            pathwayId={pathwayObject.id}
            country={country}
          />
        );

      case "Biodiversity":
        return (
          <BiodiversityTab
            data={chartData.Biodiversity ?? {}}
            pathway={pathwayName}
            pathwayId={pathwayObject.id}
            country={country}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="w-full rounded-xl bg-white overflow-hidden">
      <div className="border-b border-[#E3E5E6] px-8 pt-4 flex justify-center gap-10 text-sm font-medium text-[#101010]">
        {subTabs.map((tab) => {
          const isActive = activeSubTab === tab.key;

          return (
            <button
              key={tab.key}
              onClick={() => setActiveSubTab(tab.key)}
              className="relative pb-2"
            >
              <span className="px-2">{tab.label}</span>

              {isActive && (
                <span className="absolute left-0 right-0 -bottom-[3px] h-[3px] bg-[#54B046] rounded-full w-full mx-auto" />
              )}
            </button>
          );
        })}
      </div>

      <div className="px-8 py-6">{renderTabContent()}</div>
    </div>
  );
}